<template>
  <div class="h-100">
    <div class="card">
      <div class="card-body p-0">
        <div class="row w-100 m-0">
          <div class="col-12 tenders-list p-0">
            <tender-info-block v-if="tenderData" :tender="tenderData" :withoutActions="true"/>
            <div class="d-flex flex-wrap gap-2 padding-10">
              <div class="divider"/>
              <div class="d-flex flex-wrap padding-r-10 padding-l-10 padding-b-10">
                <div class="tender-offer-block col-12 col-md-8">
                  <div class="tender-offer-header">
                    <span>Մասնակցելու ընթացակարգ</span>
                  </div>
                  <div class="form-group w-100 padding-l-20 padding-r-20 padding-t-20 d-flex align-items-center tender-input-group tender-input-group-center">
                      <div class="d-flex p-0 col-4">
                        <p class="mr-2">
                          Ապրանքի անվանում՝
                          <Tooltip
                              class="col-auto p-0"
                              text="Առաջարկվող ապրանքի ֆիրմային անվանումը, մոդելը, ծագման երկիրն ու արտադրողը"
                          >
                              <span :id="`tooltip-target-`" class="ml-2">
                                  <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M5.82422 9.02991H6.97573V5.27234H5.82422V9.02991Z" fill="#006BE6"/>
                                      <path d="M7.03634 2.90918H5.82422V4.1213H7.03634V2.90918Z" fill="#006BE6"/>
                                      <path d="M6.42969 0C3.09635 0 0.429688 2.66667 0.429688 6C0.429688 9.33333 3.09635 12 6.42969 12C9.76302 12 12.4297 9.33333 12.4297 6C12.4297 2.66667 9.70241 0 6.42969 0ZM6.42969 10.7273C3.76302 10.7273 1.64181 8.60606 1.64181 6C1.64181 3.39394 3.76302 1.21212 6.42969 1.21212C9.09635 1.21212 11.2176 3.33333 11.2176 6C11.2176 8.66667 9.03575 10.7273 6.42969 10.7273Z" fill="#006BE6"/>
                                  </svg>
                              </span>
                          </Tooltip>
                        </p>
                      </div>
                      <textarea
                          v-model="offer.mark"
                          rows="4"
                          id="other-requirements"
                          class="tender-input col m-0"
                      ></textarea>
                    </div>
                  <div class="form-group w-100 padding-l-20 padding-r-20 padding-t-20 d-flex align-items-center tender-input-group tender-input-group-center">
                    <div class="d-flex p-0 col-4">
                      <p class="mr-2">
                        Առաքման պայմաններ՝
                      </p>
                    </div>
                    <textarea
                        v-model="offer.delivery_terms"
                        rows="4"
                        id="other-requirements"
                        class="tender-input col m-0"
                    ></textarea>
                  </div>
                  <div class="d-flex flex-wrap align-items-center w-100">
                    <div class="col-md-6 form-group w-100 padding-l-20 padding-r-20 padding-t-20 d-flex align-items-center tender-input-group tender-input-group-center">
                      <div class="d-flex p-0 col-auto">
                        <p class="mr-2">
                          Քանակ՝
                          <Tooltip
                              class="col-auto p-0"
                              text="Նշվում է այն քանակը, որը մասնակիցը կարող է պատվերը ստանալուց հետո գնման ժամանակացույցով սահմանված ժամկետում մատակարարի"
                          >
                            <span :id="`tooltip-target-`" class="ml-2">
                                <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.82422 9.02991H6.97573V5.27234H5.82422V9.02991Z" fill="#006BE6"/>
                                    <path d="M7.03634 2.90918H5.82422V4.1213H7.03634V2.90918Z" fill="#006BE6"/>
                                    <path d="M6.42969 0C3.09635 0 0.429688 2.66667 0.429688 6C0.429688 9.33333 3.09635 12 6.42969 12C9.76302 12 12.4297 9.33333 12.4297 6C12.4297 2.66667 9.70241 0 6.42969 0ZM6.42969 10.7273C3.76302 10.7273 1.64181 8.60606 1.64181 6C1.64181 3.39394 3.76302 1.21212 6.42969 1.21212C9.09635 1.21212 11.2176 3.33333 11.2176 6C11.2176 8.66667 9.03575 10.7273 6.42969 10.7273Z" fill="#006BE6"/>
                                </svg>
                            </span>
                          </Tooltip>
                        </p>
                      </div>
                      <input
                          v-model.number="offer.count"
                          v-integer-only
                          type="text"
                          name="count"
                          class="tender-input col m-0"
                      />
                      <div>
                      </div>
                    </div>
                    <div class="col-md-6 form-group w-100 padding-l-20 padding-r-20 padding-t-20 d-flex align-items-center tender-input-group tender-input-group-center">
                      <div class="d-flex p-0 col-auto">
                        <p class="mr-2">
                          Պատվերի նվազագույն քանակ՝
                        </p>
                      </div>
                      <input
                          v-model.number="offer.min_count"
                          v-integer-only
                          type="text"
                          name="count"
                          class="tender-input col m-0"
                      />
                      <div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group w-100 padding-l-20 padding-r-20 flex-wrap padding-t-20 d-flex align-items-center tender-input-group tender-input-group-center justify-content-between">
                    <div class="d-flex p-0 col-xl-7 flex-wrap">
                      <div class="col-auto p-0 d-flex align-items-center">
                        <p class="mr-2">
                          Միավորի գին (ՀՀ դրամ)՝
                          <BigTooltip
                              class="col-auto p-0"
                              text="Մասնակիցները գներ ներկայացնելիս պետք է հաշվի առնեն, որ"
                          >
                              <span :id="`tooltip-target-`" class="ml-2">
                                  <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M5.82422 9.02991H6.97573V5.27234H5.82422V9.02991Z" fill="#006BE6"/>
                                      <path d="M7.03634 2.90918H5.82422V4.1213H7.03634V2.90918Z" fill="#006BE6"/>
                                      <path d="M6.42969 0C3.09635 0 0.429688 2.66667 0.429688 6C0.429688 9.33333 3.09635 12 6.42969 12C9.76302 12 12.4297 9.33333 12.4297 6C12.4297 2.66667 9.70241 0 6.42969 0ZM6.42969 10.7273C3.76302 10.7273 1.64181 8.60606 1.64181 6C1.64181 3.39394 3.76302 1.21212 6.42969 1.21212C9.09635 1.21212 11.2176 3.33333 11.2176 6C11.2176 8.66667 9.03575 10.7273 6.42969 10.7273Z" fill="#006BE6"/>
                                  </svg>
                              </span>
                          </BigTooltip>
                        </p>
                      </div>
                      <div class="col-6 p-0">
                        <div class="d-flex justify-content-center align-items-center">
                          <input
                              v-model.number="offer.price"
                              v-positive-only.none-zero
                              style="color: #006BE6; font-weight: 600"
                              @input="handlePriceChange"
                              type="number"
                              class="tender-input w-100 m-0"
                              id="procurement-name-ru"
                          >
                          <div class="col-auto d-flex justify-content-center align-items-center">
                            <input
                                class="m-0"
                                v-model="offer.is_with_vat"
                                @change="handleVatChange"
                                :true-value="true"
                                :false-value="false"
                                type="checkbox">
                            <p class="ml-2">ԱԱՀ-ով</p>
                          </div>
                        </div>
                        <div v-if="priceGreaterThenMarket" class="form-group w-100 p-0 pt-2 m-0 d-flex align-items-center tender-input-group tender-input-group-center">
                          <span class="small m-0 helper-text text-danger font-weight-bold">Նշված գինը գերազանցում է շուկայական գինը</span>
                        </div>
                        <div v-if="equalPrice" class="form-group w-100 p-0 pt-2 m-0 d-flex align-items-center tender-input-group tender-input-group-center">
                          <span class="small m-0 helper-text text-danger font-weight-bold">Նշված գինը հավասար է ներկայացված գներից մեկին</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-5 py-3 p-xl-0 d-flex p-0 flex-wrap justify-content-end align-items-center">
                      <div class="col-auto d-flex align-items-center justify-content-center p-0">
                        <button :disabled="!offer.count" @click="setIntervals" class="send-offer-btn btn btn-primary btn հ-100">
                          <span>Սահմանել շեմեր և գներ</span>
                        </button>
                      </div>
                      <div class="col-auto d-flex align-items-center justify-content-center py-0 pr-0 padding-left-20">
                        <button :disabled="invalid || priceGreaterThenMarket || equalPrice" @click="sendOffer" class="send-offer-btn btn btn-primary btn հ-100">
                          <span>Մասնակցել</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="timeless-tender-info-block info-block col-12 col-md-4 p-0 padding-l-20">
                  <div v-if="(tenderData.lastOffers && tenderData.lastOffers.length)" class="col-auto p-0">
                    <div class="form-group d-flex align-items-center tender-input-group m-0">
                      <p class="text-secondary">Մասնակիցների քանակը`</p>
                      <p class="text-weight-d ml-2 tender-info-text">{{ offer.all_offers_count }}</p>
                    </div>
                    <div class="form-group d-flex align-items-center tender-input-group m-0 mt-2">
                      <p class="text-secondary">Զբաղեցրած տեղը՝</p>
                      <p class="text-weight-d ml-2 tender-info-text">{{ offer.my_position }}</p>
                    </div>
                    <div class="form-group d-flex align-items-center tender-input-group m-0 mt-2">
                      <p class="text-secondary">Վերջին ներկայացված գինը (դր)՝</p>
                      <p class="text-weight-d ml-2 tender-info-text">{{ offer.last_offer_price }}</p>
                    </div>
                    <div class="form-group d-flex align-items-center  tender-input-group m-0 mt-2">
                      <p class="text-secondary">Առաջին 5 տեղերը զբաղեցրած գները՝</p>
                    </div>
                    <div class="form-group d-flex align-items-center  tender-input-group m-0 mt-2">
                      <ol style="padding-left: 18px;">
                        <li :class="offer.user_id === me.id && 'text-success'"
                            :key="offer.id"
                            v-for="offer in tenderData.lastOffers"
                            class="tender-info-text"
                        >
                          <span>{{ offer.total_price }}</span>
                          <span class="mx-2">|</span>
                          <span>{{ offer.count }} {{ tenderData.unit }}</span>
                          <span class="mx-2">|</span>
                          <span>{{ offer.is_with_vat ? 'ներառյալ ԱԱՀ' : 'առանց ԱԱՀ' }} </span>
                          <span v-if="offer.user_id === me.id">
                            <i v-tooltip="'Ջնջել առաջարկը'" @click.prevent.stop="() => deleteOffer(offer.id)" class="ml-2 pointer text-danger remove far fa-trash-alt"></i>
                          </span>
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <timeless-confirm-modal/>
    <timeless-offer-interval-modal :totalCount="offer.count" :lastOffers="tenderData.lastOffers" :marketPrice="tenderData.market_price"/>
  </div>
</template>
<script>
  import isMobile from '@/mixins/isMobileView'
  import TenderInfoBlock from '@/components/timelessTenders/TenderInfoBlock.vue'
  import Tooltip from '@/components/tooltip'
  import BigTooltip from '@/components/tooltip/bigTooltip'
  import {required } from 'vuelidate/lib/validators'
  import TimelessConfirmModal from '@/components/helpers/TimelessConfirmModal.vue'
  import TimelessOfferIntervalModal from '@/components/helpers/TimelessOfferIntervalModal.vue'

  export default {
    components: { TimelessConfirmModal, TimelessOfferIntervalModal, Tooltip, TenderInfoBlock, BigTooltip },
    mixins: [isMobile],
    data() {
      return {
        dateNow: new Date(),
        backendUrl: process.env.VUE_APP_URL,
        equalPrice: false,
        tenderData: false,
        priceGreaterThenMarket: false,
        mainPicture: '',
        offerInformation: {},
        priceInterval: [],
        invalid: true,
        offer: {
          timeless_tender_id: this.$route.params.tenderId,
          count: '',
          min_count: '',
          price: null,
          is_with_vat: false,
          mark: '',
          delivery_terms: '',
        },
        columns: [
          'password',
          'title',
          'products',
          'opening_finish_date',
          'price',
          'region',
          'type',
          'invitation',
          'edit',
          'participants_count'
        ],
      }
    },
    validations: {
      offer: {
        timeless_tender_id: {},
        count: {required},
        min_count: {required},
        price: {required},
        mark: {required},
        delivery_terms: {required},
      }
    },
    computed: {
      me() {
        return this.$store.getters['user/me']
      },
      currentPlan() {
        return this.$store.getters['procurement/currentPlan']
      },
      locale() {
        return this.$store.getters['user/locale']
      }
    },
    mounted() {
      if(this.$route.params.tenderId){
        this.getInfo();
      }
    },
    watch: {
      '$v.$invalid': function(state) {
        console.log('invalid state', state)
        this.invalid = state;
      }
    },
    methods: {
      deleteOffer(offerId){
        this.$client.get(`timeless-tenders/deleteOffer/${offerId}`).then(({ data }) => {
          this.$notify({
            group: 'foo',
            type: 'success',
            text: 'Հաջողությամբ ջնջված է'
          })
          this.getInfo();
        })
      },
      getInfo(){
        this.$client.get(`timeless-tenders/${this.$route.params.tenderId}`).then(({ data }) => {
          console.log('data', data.data)
          this.tenderData = data.data;
          this.mainPicture = data.data.pictures[0];
        })
        this.$client.get(`timeless-tenders/myOffer/${this.$route.params.tenderId}`).then(({ data }) => {
          console.log('myOffer data', data)
          if(data){
            this.priceInterval = data.price_interval;
            this.offer = data;
            this.offer.timeless_tender_id = this.$route.params.tenderId;
            if(data.price){
              if(data.is_with_vat){
                this.offer.price = (+data.total_price).toFixed(0);
              } else {
                this.offer.price = (+data.price).toFixed(0);
              }
            }
            console.log('this.offer', this.offer)
          }
        })
      },
      handlePriceChange(event){
        let hasEqualPrice = false;
        const price = +event.target.value
        const vatPayer = this.me.vat_payer_type === 'payer';
        if(this.tenderData.lastOffers.length) {
          this.tenderData.lastOffers.forEach((offer) => {
            const offerPrice = vatPayer ? +offer.price : +offer.total_price;
            if (+offerPrice === price) {
              if (offer && offer.user_id !== this.me.id) {
                hasEqualPrice = true;
              }
            }
          });
        }

        if(+price > +this.tenderData.market_price){
          this.priceGreaterThenMarket  = true;
        } else {
          this.priceGreaterThenMarket  = false;
        }
        this.equalPrice = hasEqualPrice;
      },
      handleVatChange(event){
        if(event.target.checked) {
          this.offer.price = this.offer.price * 1.2;
        } else {
          this.offer.price = this.offer.price - (this.offer.price / 6);
        }
        this.priceGreaterThenMarket = +this.offer.price > +this.tenderData.market_price;
      },
      setIntervals(){
        this.$modal.show('timeless-offer-interval-modal', {
          priceIntervalArray: this.priceInterval,
          callback: async (intervalRows) => {
            this.$modal.hide('timeless-offer-interval-modal')
            console.log('intervalRows', intervalRows)
            const minPriceInterval = this.getMinimalPrice(intervalRows)
            console.log('minPriceInterval', minPriceInterval);
            this.offer.price = minPriceInterval.price;
            this.offer.is_with_vat = minPriceInterval.is_with_vat;
            this.offer.price_interval = this.cleanArray(intervalRows);
            console.log('offer', this.offer);
          }
        })
      },
      cleanArray(intervalRows) {
        return intervalRows.map(({ countGreaterThenTotal, equalPrice, priceGreaterThenMarket, ...rest }) => rest);
      },
      getMinimalPrice(intervalRows) {
        if (!Array.isArray(intervalRows) || intervalRows.length === 0) {
          return null; // Return null if input is not an array or empty
        }

        return intervalRows.reduce((minRow, currentRow) => {
          return currentRow.price < minRow.price ? currentRow : minRow;
        }, intervalRows[0]); // Start with the first row as initial min
      },
      sendOffer(){
        console.log(this.$v.offer)
        if(!this.$v.$invalid) {
          if(this.offer.id){
            this.$client.post('timeless-tenders/updateOffer', this.offer).then(({data}) => {
              if(data){
                this.$notify({
                  group: 'foo',
                  type: 'success',
                  text: 'Հաջողությամբ խմբագրված է'
                })
                this.getInfo();
                this.isSaving = false;
                // this.$router.push('/timeless-tenders/buy/list')
              }
            }).catch(() => {
              this.$notify({
                group: 'foo',
                type: 'error',
                text: 'Լրացրեք բոլոր դաշտերը հաստատելու համար!'
              })
            })
          } else {
            this.$modal.show('timeless-confirm-modal', {
              msg: 'tender',
              callback: async () => {
                this.$modal.hide('timeless-confirm-modal')
                console.log('this.offer', this.offer)
                this.$client.post('timeless-tenders/sendOffer', this.offer).then(({data}) => {
                  if(data){
                    this.getInfo();
                    this.$notify({
                      group: 'foo',
                      type: 'success',
                      text: 'Հաջողությամբ հաստատված է'
                    })
                  }
                }).catch(({ data }) => {
                  this.$modal.hide('timeless-confirm-modal')
                  this.$notify({
                    group: 'foo',
                    type: 'error',
                    text: data.message || 'Ինչ որ բան այն չէ, կրկին փորձեք!'
                  })
                })
              }
            })
          }
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Լրացրեք բոլոր դաշտերը հաստատելու համար!'
          })
        }

      },
    },
  }
</script>
<style scoped>
.text-secondary{
  font-size: 13px;
}
.tender-info-text{
  font-size: 16px;
  font-weight: 600;
}
.divider{
  margin: 6px 10px 16px;
}
.tender-offer-block{
  padding: 0px !important;
  display: flex !important;
  flex-wrap: wrap;
  border: 1px solid #EDEFF2;
  border-radius: 12px;


  .send-offer-btn[disabled]{
    background: #EDEFF2 !important;
    border: none !important;
    span{
      color: #6E7485;
    }
  }

  .send-offer-btn{
    height: 48px;
    border-radius: 8px;

    span{
      font-size: 16px !important;
      font-weight: 500;
    }
  }

  .tender-offer-header{
    width: 100%;
    height: 56px;
    background: #EDEFF2;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    padding: 16px 20px;

    span{
      font-size: 16px;
      font-weight: 600;
    }
  }
}
@media (max-width: 768px) {
  .timeless-tender-info-block{
    padding: 20px 0 0 0 !important;
  }
}
</style>

